var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatWithUsList4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 2.5V15C19.5469 16.375 18.4219 17.5 17.0469 17.5H3.29688V9.52499C4.20938 10.6125 5.60941 11.2875 7.15941 11.25C8.42191 11.225 9.55938 10.7375 10.4094 9.925C10.7969 9.6 11.1219 9.18749 11.3719 8.73749C11.8219 7.97499 12.0719 7.07497 12.0469 6.13747C12.0094 4.67497 11.3594 3.3875 10.3469 2.5H19.5469Z",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2969 17.5V21.25C28.2969 23.325 26.6219 25 24.5469 25H23.2969C23.2969 23.625 22.1719 22.5 20.7969 22.5C19.4219 22.5 18.2969 23.625 18.2969 25H13.2969C13.2969 23.625 12.1719 22.5 10.7969 22.5C9.42187 22.5 8.29688 23.625 8.29688 25H7.04688C4.97188 25 3.29688 23.325 3.29688 21.25V17.5H17.0469C18.4219 17.5 19.5469 16.375 19.5469 15V6.25H21.8469C22.7469 6.25 23.5719 6.73751 24.0219 7.51251L26.1593 11.25H24.5469C23.8594 11.25 23.2969 11.8125 23.2969 12.5V16.25C23.2969 16.9375 23.8594 17.5 24.5469 17.5H28.2969Z",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7969 27.5C12.1776 27.5 13.2969 26.3807 13.2969 25C13.2969 23.6193 12.1776 22.5 10.7969 22.5C9.41616 22.5 8.29688 23.6193 8.29688 25C8.29688 26.3807 9.41616 27.5 10.7969 27.5Z",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7969 27.5C22.1776 27.5 23.2969 26.3807 23.2969 25C23.2969 23.6193 22.1776 22.5 20.7969 22.5C19.4162 22.5 18.2969 23.6193 18.2969 25C18.2969 26.3807 19.4162 27.5 20.7969 27.5Z",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2969 15V17.5H24.5469C23.8594 17.5 23.2969 16.9375 23.2969 16.25V12.5C23.2969 11.8125 23.8594 11.25 24.5469 11.25H26.1593L28.2969 15Z",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0483 6.13841C12.0733 7.07591 11.8233 7.97593 11.3733 8.73843C11.1233 9.18843 10.7983 9.60094 10.4108 9.92594C9.56081 10.7384 8.42334 11.2259 7.16084 11.2509C5.61084 11.2884 4.21081 10.6134 3.29831 9.52593C3.12331 9.33843 2.97332 9.12595 2.83582 8.91345C2.34832 8.17595 2.07331 7.30097 2.04831 6.36347C2.01081 4.78847 2.7108 3.35093 3.8358 2.41343C4.6858 1.71343 5.76078 1.27594 6.93578 1.25094C8.24828 1.22594 9.44833 1.70094 10.3483 2.50094C11.3608 3.38844 12.0108 4.67591 12.0483 6.13841Z",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09375 6.28796L6.35626 7.48792L8.96872 4.96289",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWithUsList4);
export default __webpack_public_path__ + "static/media/chatWithUsList4.b771d59ce96c4e167acd6b27772267d1.svg";
export { ForwardRef as ReactComponent };